export default {

  getTranslatedPolicyTypeField: (state) => (locale, list, table, selectionColumn, selectionKey) => {
    if (selectionKey.length == 0) {
      return 'N/A'
    }
    const criteria = { tableName: `osm_gi_${table}`, selectionColumn: selectionColumn, selectionKey: selectionKey }
    var obj = list.filter((item) => {
      return Object.keys(criteria).every((c) => {
        return item[c] == criteria[c];
      });
    });
    if (obj.length == 0) {
      return selectionKey
    }
    var selectionItemToBeGet = 'selectionValueEnglish';
    switch (locale.toLowerCase()) {
      case 'en_us':
        selectionItemToBeGet = 'selectionValueEnglish';
        break;
      case 'zh_hk':
        selectionItemToBeGet = 'selectionValueZhHk';
        break;
      case 'zh_cn':
        selectionItemToBeGet = 'selectionValueZhCn';
        break;
    }
    return obj[selectionItemToBeGet];
  },

  getTranslatedOptions: (state) => (locale, itemList) => {
    var selectionItemToBeGet = 'selectionValueEnglish';
    var translatedOptionsList = [];
    switch (locale.toLowerCase()) {
      case 'en_us':
        selectionItemToBeGet = 'selectionValueEnglish';
        break;
      case 'zh_hk':
        selectionItemToBeGet = 'selectionValueZhHk';
        break;
      case 'zh_cn':
        selectionItemToBeGet = 'selectionValueZhCn';
        break;
    }
    itemList.forEach((item) => {
      translatedOptionsList = [...translatedOptionsList,
        { value: item.selectionKey, text: item[selectionItemToBeGet] }
      ]
    })
    return translatedOptionsList;
  },

  getTranslatedPolicyTypeList: (state) => (locale) => {
    var selectionItemToBeGet = 'selectionValueEnglish';
    var translatedTypeList = [];
    switch (locale.toLowerCase()) {
      case 'en_us':
        selectionItemToBeGet = 'selectionValueEnglish';
        break;
      case 'zh_hk':
        selectionItemToBeGet = 'selectionValueZhHk';
        break;
      case 'zh_cn':
        selectionItemToBeGet = 'selectionValueZhCn';
        break;
    }
    var policyTypeList = state.newGI.policyTypeList;

    policyTypeList.forEach((item) => {
      translatedTypeList = [...translatedTypeList,
        { value: item.selectionKey, text: item[selectionItemToBeGet] }
      ]
    })
    return translatedTypeList;
  },

  getTranslatedPolicyFields: (state) => (locale) => {
    var selectionItemToBeGet = 'selectionValueEnglish';
    var translatedFieldList = [];
    switch (locale.toLowerCase()) {
      case 'en_us':
        selectionItemToBeGet = 'selectionValueEnglish';
        break;
      case 'zh_hk':
        selectionItemToBeGet = 'selectionValueZhHk';
        break;
      case 'zh_cn':
        selectionItemToBeGet = 'selectionValueZhCn';
        break;
    }

    var giProductFieldList = state.newGI.policyFields;
    giProductFieldList.forEach((item) => {
      if (item.field === 'version') {
        return;
      }
      switch (item.type) {
        case "selection":
          var translatedOptions = [];
          var selectionFieldOptions = item.options;


          selectionFieldOptions.forEach((option) => {
            translatedOptions = [
              ...translatedOptions,
              { ID: option.ID, selectionColumn: option.selectionColumn, value: option.selectionKey, text: option[selectionItemToBeGet] }
            ]
          })
          translatedFieldList = [
            ...translatedFieldList,
            { fieldName: item.field, type: item.type, options: translatedOptions }
          ]

          break;

        case "number":
        case "string":
          translatedFieldList = [
            ...translatedFieldList,
            { fieldName: item.field, type: item.type }
          ]
          break;
      }
    })
    return translatedFieldList;
  }
}



// WEBPACK FOOTER //
// ./src/Osm/GIPolicy/store/getters.js